import { orderBy } from 'lodash';
import { TagGroupAnalysisGq } from '../../../../../graphql/projects/queries/analysis/useGetRankIntervalsPerTagGroup';
import { rankIntervals, rankSegmentNames } from '../../../IntervalsAndColorsLogic';

// Main function for creating data for the chart
export const getBarValues = (tagGroupAnalyses: TagGroupAnalysisGq[]) => {
  const orderedAnalyses = orderBy(tagGroupAnalyses, [(g) => g.searchVolume], ['desc']);
  return orderedAnalyses.map((tagGroupAnalysis) => {
    let bar: any = {};

    // Set the bar name
    bar.barName = tagGroupAnalysis.tagGroupName;

    // Set the segment values of the bar
    rankIntervals.map((rankInterval, index) => {
      // Find data point (not always present)
      const intervalAnalysis = tagGroupAnalysis.intervalAnalyses.find(
        (ia) => ia.startRank === rankInterval.startRank && ia.endRank == rankInterval.endRank
      );

      // Calculate value
      let barSegmentValue = 0;
      if (tagGroupAnalysis.keywordCount > 0 && intervalAnalysis?.keywordCount > 0) {
        barSegmentValue = (intervalAnalysis.keywordCount / tagGroupAnalysis.keywordCount) * 100;
      }

      // Assign value
      const barSegmentName = rankSegmentNames[index];
      bar[barSegmentName] = barSegmentValue;
    });
    return bar;
  });
};
